import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Text,
  VStack,
  Heading,
  InputGroup,
  InputLeftElement,
  InputRightElement, //icono derecho
  IconButton,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'; 
import { colors } from '../../utils/theme/styles';

export default function InputForm({
  title,
  variant = 'overline',
  value = '',
  onChange = () => null,
  titleHeading = false,
  color,
  stackProps,
  icon,
  onClear, // Nuevo prop para manejar el evento de limpiar el input
  ...rest
}) {
  const Title = useMemo(() => {
    if (titleHeading) {
      return Heading;
    }
    return Text;
  }, [titleHeading]);

  return (
    <VStack {...stackProps} alignItems="flex-start" spacing="8px">
      <Title color={color} textAlign="left" variant={variant}>
        {title}
      </Title>
      <InputGroup>
        {icon && (
          <InputLeftElement pointerEvents="none">
            <FontAwesomeIcon icon={icon} color={colors.text.icon} />
          </InputLeftElement>
        )}
        <Input
          _disabled={{ color: colors.gray[400], cursor: 'not-allowed' }}
          value={value}
          onChange={onChange}
          {...rest}
        />
        {value && (
          <InputRightElement>
            <IconButton
              aria-label="Clear input"
              icon={<FontAwesomeIcon icon={faTimes} />}
              onClick={onClear} //evento manejado externamente
              size="sm"
              variant="ghost"
            />
          </InputRightElement>
        )}
      </InputGroup>
    </VStack>
  )
}

InputForm.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.any,
  onChange: PropTypes.func,
  onClear: PropTypes.func, //nuevo prop
  stackProps: PropTypes.object,
  title: PropTypes.string,
  titleHeading: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.string,
};
